import { Card, Select, Table } from 'antd';
import { useState } from 'react';
import { useTopVendors } from './hooks/useTopVendors';
import { fmtCents } from './shared/formatCents';
import { defaultBudgetItemsConfig } from '../../../../../../types/apiTypes';
import { unicodeToEmoji } from '../../../../../../shared/emojiUnicode';

const EXPENSE_CATEGORY_OPTIONS = Object.values(defaultBudgetItemsConfig).map(
  (item) => ({
    value: item.category,
    label: `${unicodeToEmoji(item.emoji_unicode)} ${item.category_display_name}`,
  })
);

export function TopVendorsCard({
  customerId,
  year,
}: {
  customerId: string;
  year: number;
}) {
  const [category, setCategory] = useState<string | undefined>();
  const { data, isLoading } = useTopVendors(customerId, year, category);

  if (isLoading || !data) return <Card title="Top Vendors" loading />;

  return (
    <Card>
      <div className="mb-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <h3 className="m-0 text-base font-semibold">Top Expenses</h3>
        <Select
          className="w-full sm:w-60"
          allowClear
          placeholder="All categories"
          value={category}
          onChange={setCategory}
          options={EXPENSE_CATEGORY_OPTIONS}
        />
      </div>
      <Table
        dataSource={data.vendors}
        rowKey="vendor"
        columns={[
          { title: 'Vendor', dataIndex: 'vendor', width: 220 },
          {
            title: 'Total',
            dataIndex: 'total',
            align: 'right' as const,
            width: 130,
            render: fmtCents,
          },
          {
            title: '# Transactions',
            dataIndex: 'transaction_count',
            align: 'right' as const,
            width: 140,
          },
        ]}
        pagination={false}
        size="small"
        scroll={{ x: 'max-content' }}
      />
    </Card>
  );
}
